import interceptorAxios from './InterceptorAxios';

const ServicioContrasena={

    cambioContrasena(objeto){
        return interceptorAxios.post('/usuario/recuperar_contrasena.json',objeto);
    },

}

export default ServicioContrasena;